import { createFileRoute } from "@tanstack/react-router";
import React, { Suspense, lazy } from "react";

// Read-only LL87 submission overview — the "View submission" destination,
// Tracker-native (mirrors `portal/buildings_/.../ll97.tsx`; see the
// index route's comment for the `buildings_` escape-hatch rationale).
// Resolved via the entry.tsx seam so the Stage-D evidence vault lands by
// flipping one export line there. The filing flow lives at the index
// route. NO SiteHeader/backLink here — that is classic `/buildings`
// chrome; this surface is Tracker-native.
const LL87SubmissionOverviewPage = lazy(() =>
  import("@/pages/Filings/LL87Submission/entry").then((m) => ({
    default: m.LL87SubmissionOverviewPage,
  })),
);

export const Route = createFileRoute(
  "/portal/buildings_/$buildingId/ll87_/$ll87SubmissionId/overview",
)({
  // FR-C-9 — the validated `?tab=` deep-link (PhaseDobReview links
  // `?tab=communication`). The page's `parseVaultTab` re-validates the raw
  // value against the union and falls back to `documents` on anything unknown.
  validateSearch: (search: Record<string, unknown>): { tab?: string } => ({
    tab: typeof search.tab === "string" ? search.tab : undefined,
  }),
  component: () => {
    const { buildingId, ll87SubmissionId } = Route.useParams();
    const { tab } = Route.useSearch();
    return (
      <Suspense fallback={null}>
        <LL87SubmissionOverviewPage
          buildingId={buildingId}
          submissionId={ll87SubmissionId}
          initialTab={tab}
        />
      </Suspense>
    );
  },
});
